import React from "react";

import { HeatMapItem } from "../../heat_map_item/heat_map_item";
import { HeatMap } from "../../heat_map_item/heat_map_item.types";
import { useAvailabilityLabel } from "../hooks/use_availability_label";
import { useBackgroundColor } from "../hooks/use_background_color";

const BORDER_WIDTH = 1;
const MIN_WIDTH_FOR_LABEL = 45;

type AvailabilityItemProps = {
  item: HeatMap;
};

export const AvailabilityItem = ({ item }: AvailabilityItemProps): JSX.Element => {
  const {
    available_minutes: availableMinutes,
    nominal_working_minutes: nominalWorkingMinutes,
    width,
    left
  } = item;
  const fullWidth = width - BORDER_WIDTH;

  const availabilityLabel = useAvailabilityLabel({
    availableMinutes,
    nominalWorkingMinutes
  });
  const bgColor = useBackgroundColor({ availableMinutes, nominalWorkingMinutes });
  const shouldDisplayLabel = fullWidth > MIN_WIDTH_FOR_LABEL;

  return (
    <HeatMapItem
      {...item}
      left={left}
      width={fullWidth}
      label={availabilityLabel}
      bgColor={bgColor}
      shouldDisplayLabel={shouldDisplayLabel}
    />
  );
};
